import { render } from "./App.vue?vue&type=template&id=19452842"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./App.vue?vue&type=style&index=0&id=19452842&lang=scss"

import exportComponent from "C:\\Users\\ASUS\\Documents\\PROFESSIONNEL\\DVPT-WEB\\pierre-hydraulic\\phs-website-Vuejs-V1.1.1\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__